import React from "react";
import { FaApple, FaGooglePlay } from "react-icons/fa";

const APP_STORE_URL = process.env.REACT_APP_APP_STORE_URL || "https://apps.apple.com/";
const PLAY_STORE_URL = process.env.REACT_APP_PLAY_STORE_URL || "https://play.google.com/store";

export default function AppUnlockModal({
  open,
  onClose,
  title = "Unlock all features",
  message = "Install the app to save favorites and access full experience.",
}) {
  if (!open) return null;

  return (
    <div className="app-unlock-modal" role="dialog" aria-modal="true" aria-label="Unlock all features">
      <div className="app-unlock-card">
        <button type="button" className="app-unlock-close" onClick={onClose} aria-label="Close popup">
          ×
        </button>
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="app-unlock-store-links">
          <a href={APP_STORE_URL} target="_blank" rel="noreferrer noopener">
            <FaApple />
            <span>App Store</span>
          </a>
          <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer noopener">
            <FaGooglePlay />
            <span>Play Store</span>
          </a>
        </div>
      </div>
    </div>
  );
}

